export const APP_IDENTIFIER = 'quick-filters-settings';
export const APP_TEAM_NAME = 'a4t-pandora';
export const APP_SOURCE_NAME = 'quickFiltersSettings';
export const APP_BOUNDARY_ID = 'jira.board-settings.cmp.quick-filters';

export const APP_CMP_METRIC_KEY = `software.cmp.boards.${APP_IDENTIFIER}`;
